import React from 'react';
import {useTranslation} from "react-i18next";
import CustomDaySelector from "../../../../../components/CustomDaySelector";
import CustomTimePicker from "../../../../../components/CustomTimePicker";
import DividerWithText from "../../../../../components/DividerWithText";
import {CustomAddChip} from "../../../../../components/CustomAddChip";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const CafeteriaAccess = ({
    item,
    emptyFields,
    disabled,
    handleChange,
    dayArray,
    setDayArray,
    deviceList,
    deviceSelectedList,
    setDeviceSelectedList,
    isValidCloseTime
}) => {
    const {t} = useTranslation();

    return (<>
        <div className={`col-12 input-padding-bottom`}>
            <DividerWithText title={t('schedule')} />
        </div>
        <div className='col-12 d-flex justify-content-center px-0 input-padding-bottom'>
            <CustomDaySelector
                id="cb_ca_day_selector"
                dayArray={dayArray}
                setDayArray={setDayArray}
                required={true}
                emptyFields={emptyFields}
            />
        </div>
        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomTimePicker
                title={t('opening')}
                name='openTime'
                value={item?.openTime}
                handleChange={(value) => {
                    handleChange({target:{name:"openTime", value:value}});
                }}
                disabled={false}
                inputFormat='HH:mm:ss'
                required
                id={'tp_ca_open_time'}
                actions={['accept', 'cancel']}
                emptyFields={emptyFields}
                formatValue={true}
            />
        </div>
        <div className='col-sm-12 col-md-6 col-lg-6 col-xl-6'>
            <CustomTimePicker
                title={t('closing')}
                name='closeTime'
                value={item.closeTime}
                handleChange={(value) => handleChange({target:{name:"closeTime", value:value}})}
                disabled={disabled || !item.openTime}
                inputFormat='HH:mm:ss'
                required
                id={'tp_ca_close_time'}
                actions={['accept', 'cancel']}
                emptyFields={(disabled || !item.openTime) ? false: emptyFields}
                isValid={isValidCloseTime}
                isValidText={'end_date_cannot_be_before_start_date'}
                formatValue={true}
                minTime={item.openTime}

            />
        </div>

        <div className={`col-12 input-padding-bottom`}>
            <DividerWithText title={t('devices_access')} />
        </div>
        <div className={"col-12 mb-5"}>
            <CustomAddChip
                autocompleteId={'slt_ca_devices'}
                buttonId={'btn_ca_add_device'}
                disabled={disabled}
                label={t("devices")}
                required={false}
                data={deviceList}
                selectedList={deviceSelectedList}
                setSelectedList={setDeviceSelectedList}
                chipIcon={null}
                showRenderOption={true}
                reset={false}
            />
        </div>
    </>)
}

export default CafeteriaAccess;
